import { inject, Injector } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take, timeout } from 'rxjs';
import { AuthService } from '../services/auth.service';

/** Longest a DDR link waits for /users/me before it decides on the cached session. */
const USER_WAIT_MS = 10_000;

/**
 * CIQ-2434: a DDR link opens chat when DDR is off for this workspace, whether the
 * release gate or the plan turns it off. The plan gate still refuses DDR work.
 */
export const ddrIncludedGuard: CanActivateFn = () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const decide = () => (auth.ddrEnabled() ? true : router.createUrlTree(['/chat']));
    if (auth.userConfirmed()) {
        return decide();
    }
    return toObservable(auth.userConfirmed, { injector: inject(Injector) }).pipe(
        filter(Boolean),
        take(1),
        timeout({ first: USER_WAIT_MS, with: () => [true] }),
        map(decide)
    );
};
